import classNames from 'classnames'
import {SvgIcon} from './SvgIcon'

export const BugIcon: SvgIcon = ({
  width = 36,
  height = 36,
  strokeColor = '',
  strokeWidth = 1.2,
  fillColor = '#00000000',
  viewBox = '0 0 34 34',
  classes,
}) => (
  <svg
    data-cy="aeroplane-icon"
    aria-label="Debug Icon"
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      d="M7.89648 12.9648C7.89648 10.6985 9.73366 8.86133 11.9999 8.86133C14.2662 8.86133 16.1034 10.6985 16.1034 12.9648V14.8958C16.1034 17.1621 14.2662 18.9993 11.9999 18.9993C9.73366 18.9993 7.89648 17.1621 7.89648 14.8958V12.9648Z"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 9.10352V18.7587"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.8623 6.57701C8.8623 5.70605 9.56836 5 10.4393 5H13.5612C14.4321 5 15.1382 5.70605 15.1382 6.57701C15.1382 7.57239 14.3313 8.37931 13.3359 8.37931H10.6646C9.66922 8.37931 8.8623 7.57239 8.8623 6.57701Z"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.65517 14.6543L6.27112 15.1576C5.50799 15.4351 5 16.1604 5 16.9724V18.9991"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.13793 11.0338L6.01553 9.89098C5.39005 9.55418 5 8.90115 5 8.19076V5.96484"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.3447 14.6543L17.7288 15.1576C18.4919 15.4351 18.9999 16.1604 18.9999 16.9724V18.9991"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.8623 11.0338L17.9847 9.89098C18.6102 9.55418 19.0002 8.90115 19.0002 8.19076V5.96484"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const PowerIcon: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = '',
  strokeWidth = 1.5,
  fillColor = '#00000000',
  classes,
}) => (
  <svg
    data-cy="aeroplane-icon"
    width={width}
    height={height}
    fill={fillColor}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      d="M6.87348 6.875C4.04217 9.7063 4.04217 14.2967 6.87348 17.128C9.70478 19.9593 14.2952 19.9593 17.1265 17.128C19.9578 14.2967 19.9578 9.7063 17.1265 6.875"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 4.75V11.25"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const EndpointRefreshIcon: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = 'text-white',
  strokeWidth = 1.5,
  classes,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    onClick={onClick}
    viewBox="0 0 24 24"
    fill="none"
    className={`stroke-current ${strokeColor} ${classes}`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.25 4.75L8.75 7L11.25 9.25"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.75 19.25L15.25 17L12.75 14.75"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.75 7H13.25C16.5637 7 19.25 9.68629 19.25 13V13.25"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.25 17H10.75C7.43629 17 4.75 14.3137 4.75 11V10.75"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export const EndpointDownloadIcon: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = 'text-white',
  strokeWidth = 1.5,
  classes,
  onClick,
}) => (
  <svg
    width={width}
    onClick={onClick}
    height={height}
    className={`stroke-current ${strokeColor} ${classes}`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.25 13.75L12 19.25L6.75 13.75"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 18.25V4.75"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const FilterIcon: SvgIcon = ({
  width = 16,
  height = 16,
  strokeColor = 'text-white',
  strokeWidth = 1.5,
  fillColor = '#00000000',
  classes,
  datacy = 'filter-icon',
}) => (
  <svg
    data-cy={datacy}
    width={width}
    height={height}
    viewBox="0 0 16 14"
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    className={classNames('stroke-current', strokeColor, classes)}
  >
    <path
      d="M4 4H11.25"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 7H9.14286"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 10H7.42857"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const CloseIcon: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = '#00AEEA',
  strokeWidth = 1.5,
  classes,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    data-cy="close-icon"
    onClick={onClick}
    viewBox="0 0 24 24"
    fill="none"
    className={`stroke-current ${strokeColor} ${classes}`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.25 6.75L6.75 17.25"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.75 6.75L17.25 17.25"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const UpArrowIcon: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = '#00000000',
  strokeWidth = 1.5,
  classes,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    onClick={onClick}
    fill="none"
    viewBox="0 0 24 24"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.25 14.25L12 10.75L8.75 14.25"
    />
  </svg>
)
export const DownArrowIcon: SvgIcon = ({
  width = 24,
  height = 24,
  strokeColor = '#00000000',
  strokeWidth = 1.5,
  classes,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    onClick={onClick}
    fill="none"
    viewBox="0 0 24 24"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M15.25 10.75L12 14.25L8.75 10.75"
    />
  </svg>
)
